module.exports = __webpack_public_path__ + "static/img/widget-1.b4e7934d.png";